class ToggleDarkMode {
	
	/**
	 * toggle an image depending on theme color mode
	 * @param lightModeImages - elementDOM - picture element image
	 * @param darkModeImages - elementDOM - picture element image
	 */
	static toggleImageMode(lightModeImages, darkModeImages) {
		if (localStorage.getItem('colorMode') === 'dark') {
			lightModeImages.forEach((lightModeImage) => {
				lightModeImage.classList.add('d-none');
			});
			darkModeImages.forEach((darkModeImage) => {
				darkModeImage.classList.remove('d-none');
			});
		} else {
			lightModeImages.forEach((lightModeImage) => {
				lightModeImage.classList.remove('d-none');
			});
			darkModeImages.forEach((darkModeImage) => {
				darkModeImage.classList.add('d-none');
			});
		}
	}
	
}

module.exports = ToggleDarkMode;